import React from "react";
import { useSelector } from "react-redux";
import "./style.scss";
import SellerFooterInfo from "./SellerFooterInfo";
import { useTranslation } from "react-i18next";
import EALink from "../../app/components/shared/Link/EALink";
import EAPageMessage from "../../app/components/shared/EAPageMessage";
import { State } from "../../app/store";
import useShowNavBar from "../NavBar/hooks/useShowNavBar";
import LinkedFacilitiesSwitcher from "../NavBar/shared/LinkedFacilitiesSwitcher";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const showNavBar = useShowNavBar();
  const messageFooter = useSelector((state: State) => state.config.configuration?.message_footer ?? "");

  if (!showNavBar) {
    return <></>;
  }

  return (
    <>
      <EAPageMessage message={messageFooter} />
      <div className={"footer"}>
      <div className="footer__facility-switcher">
        <LinkedFacilitiesSwitcher />
      </div>
      <div className="footer__content flex-between flex-wrap">
        <span>
          <SellerFooterInfo />
        </span>
        <div className="flex-center-center">
          <span>
            {t("dostawca_systemu_do_sprzedazy_biletow_karnetow_i_uslug_online_jest_eaktywni")}
            <EALink to="https://www.eaktywni.pl" title="www.eAktywni.pl" />
          </span>
        </div>
      </div>
    </div>
    </>
  );
};

export default Footer;
